import React, { useState, useEffect, useRef } from 'react'

import {
  Modal, Button
} from 'react-bootstrap';

import _ from 'lodash';
import cx from 'classnames';

import styles from './componentStyles.module.scss'

export const ModalHeader = ({
  headerName,
  onClose,
  type,
  onAddAssets,
  layoutId,
  isPersonalizeOpen,
  onTogglePersonalize,
}) => {

  return (
    <Modal.Header
      className={styles.header}
      onMouseDown={(e) => e.stopPropagation()}
      onClick={(e) => e.stopPropagation()}
    >
      <div className={styles.modalDetails}>
        <div className={styles.title}>
          {headerName}
        </div>
        <div className={cx(styles.typeLabel, {[styles.higlight]: type === 'dynamic'})}>{type}</div>
        {/* <div className={styles.gatingSection}>
        <span className={styles.label}>Section Gating</span>
        <Button variant='info'><i className={cx(styles.lockIcon, 'cleverstory-unlock')} /></Button>
      </div> */}
      </div>
      <div className={styles.actions}>
        {layoutId && onTogglePersonalize && (
          <Button
            type="button"
            variant="info"
            active={isPersonalizeOpen}
            className={styles.actionButton}
            onMouseDown={(e) => e.stopPropagation()}
            onClick={(e) => {
              e.stopPropagation();
              onTogglePersonalize(e);
            }}
            title={isPersonalizeOpen ? 'Exit personalization' : 'Personalization'}
          >
            <i className={cx(styles.icon, 'cleverstory-user-role')} />
          </Button>
        )}
        {type == 'manual' && !isPersonalizeOpen &&
          <Button
            className={cx(styles.actionButton)}
            variant="primary"
            type="submit"
            onClick={onAddAssets}
          >
            <i className={cx(styles.icon, 'cleverstory-plus')} />
            Add Content
          </Button>
        }
        <Button type="button" variant='info' onClick={onClose} className={cx(styles.closeButton)}>
          <i className={cx("cleverstory-close")} />
        </Button>
      </div>
    </Modal.Header>
  )
}

export const Footer = ({
  type,
  filtered,
  onSave,
  selected,
  updating,
  saveDisabled,
  showPersonalizationCancel = false,
  onCancelPersonalization,
  personalizationCancelDisabled = false,
}) => {

  return (
    <div className={styles.footer}>
      {type === 'dynamic' ?
      <span className={cx(styles.selectedLabel, {[styles.show]: selected > -1})}>Filtered: {filtered}</span>  
      :
      <span className={cx(styles.selectedLabel, {[styles.show]: selected > -1})}>Selected: {selected}</span>}
      <div className={styles.footerActions}>
        {showPersonalizationCancel && onCancelPersonalization && (
          <Button
            type="button"
            size="sm"
            variant="secondary"
            className={styles.cancelButton}
            onClick={onCancelPersonalization}
            disabled={personalizationCancelDisabled || updating}
          >
            Cancel
          </Button>
        )}
        <Button
          size="sm"
          onClick={onSave}
          className={styles.saveButton}
          variant="primary"
          disabled={saveDisabled || updating}
        >
          {updating ? `Saving` : `Save & Close`}
        </Button>
      </div>
    </div>
  )
}

export const getFieldSelector = (mapping, key) => {
  const fields = _.get(mapping, 'fields') || [];
  const field = fields.find(item => item.name === key);

  return field;
}

export const getContentForFieldSelector = (mapping, key) => {
  const field = getFieldSelector(mapping, key);

  if (!field) {
    return null;
  }

  return _.get(field, `content`);
}
